import { createAction } from '@ngrx/store';

export const openContactSupportDrawer = createAction('[Common Contact Support] Open contact support drawer');
export const showCookieSettings = createAction('[Common Cookie Settings] Show cookie settings');
export const openNotificationsDrawer = createAction('[Common Notifications] Open notifications drawer');
